export default __webpack_public_path__ + "static/media/cake1.333ffde7.jpg";